import templateUrl from './integer.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterInteger', {
        bindings: {
            store: '<',
            col: '<',
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-integer.js